import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/node_modules/.pnpm/next@16.0.10_@babel+core@7.25.8_@playwright+test@1.56.1_babel-plugin-react-compiler@1.0_4fdc3e2f97142a2def1948f440a28815/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/onlyoffice/src/client/packages/login/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/packages/login/src/styles/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/onlyoffice/src/client/packages/login/src/utils/registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toast"] */ "/app/onlyoffice/src/client/packages/shared/components/toast/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/packages/shared/styles/theme.scss");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ar-SA.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/az.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/bg.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/cs.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/de-AT.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/de-CH.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/de.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/el-GR.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/en-GB.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/en-US.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/es-MX.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/es.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/fi.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/fr.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/hy-AM.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/it.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ja-JP.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ko-KR.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/lo-LA.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/lv.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/nl.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/pl.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/pt-BR.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/pt.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ro.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ru.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/si.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/sk.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/sl.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/sq-AL.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/sr.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/tr.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/uk-UA.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/vi.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/zh-CN.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/logo/favicon.ico");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.apple.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.facebook.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.google.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.linkedin.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.microsoft.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.weixin.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.zoom.react.svg");
